import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { themeOrange } from "../../utils/colorTheme";

const ContractRequiredDialog = () => {
  const [open, setOpen] = useState(false);
  const [signUrl, setSignUrl] = useState("/contract");
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e) => {
      setSignUrl(e.detail?.sign_url || "/contract");
      setOpen(true);
    };
    window.addEventListener("app:contract-required", handler);
    return () => window.removeEventListener("app:contract-required", handler);
  }, []);

  const goSign = () => {
    setOpen(false);
    const path = signUrl.startsWith("/pro/") ? signUrl.replace("/pro", "") : signUrl;
    navigate(path);
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>Sign the agreement first</DialogTitle>
      <DialogContent>
        <Typography sx={{ color: "#444" }}>
          Before you can accept this you have to sign the agreement.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={() => setOpen(false)} sx={{ color: "#666", textTransform: "none" }}>
          Not now
        </Button>
        <Button
          onClick={goSign}
          variant="contained"
          sx={{
            bgcolor: themeOrange,
            "&:hover": { bgcolor: "#C53F10" },
            textTransform: "none",
            fontWeight: 600,
          }}
        >
          Go to Provider Agreement
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContractRequiredDialog;
